
import { defineComponent } from "vue";
import TopBar from "./TopBar.vue";

export default defineComponent({
  name: 'Demo',
  props: {
    msg: String
  },
  components: {
    TopBar
  },
  data () {
    return {
    
    }
  }
})
